export const errorMessages = {
  invalid_password: 'Please use a stronger password with a combination of symbols, uppercase and lowercase letters, and numbers.',
  password_not_match: 'Passwords is not match. Please make sure you have typed the same password in both fields.'
};
